import { render, staticRenderFns } from "./review_microbiology.vue?vue&type=template&id=22b358e4&"
import script from "./review_microbiology.vue?vue&type=script&lang=js&"
export * from "./review_microbiology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports